import { B200, B400, B500, B75, DN0, DN400, N30, N500 } from '@atlaskit/theme/colors';
var navItemColorMap = {
  light: {
    labelColor: N500,
    activeLabelColor: B500,
    hoverLabelColor: B400,
    selectedColor: B400
  },
  dark: {
    labelColor: DN400,
    activeLabelColor: B200,
    hoverLabelColor: B75,
    selectedColor: B75
  }
};
export var getNavItemColors = function getNavItemColors(mode) {
  return navItemColorMap[mode];
};
var navLineColorMap = {
  light: {
    lineColor: N30,
    selectedColor: B400
  },
  dark: {
    lineColor: DN0,
    selectedColor: B75
  }
};
export var getNavLineColor = function getNavLineColor(mode) {
  return navLineColorMap[mode];
};